import { createSlice } from "@reduxjs/toolkit";
import {
  getSuppliers,
  addSupplier,
  deleteSupplier,
  updateSupplier,
} from "./thunk";
import { toast } from "react-toastify";
export const initialState = {
  suppliers: [],
  error: {},
  loading: false,
  pagination: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 317,
    totalPages: 7,
  },
};

const SuppliersSlice = createSlice({
  name: "SuppliersSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getSuppliers.pending, (state, action) => {
      state.loading = true;
      state.suppliers = [];
      state.error = {};
    });

    builder.addCase(getSuppliers.fulfilled, (state, action) => {
      state.suppliers = action.payload.data;
      if (action.payload.pagination)
        state.pagination = action.payload.pagination;
      state.loading = false;
    });

    builder.addCase(getSuppliers.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(addSupplier.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Adding Supplier...", {
        position: "top-center",
        autoClose: false,
      });
      state.error = {};
    });

    builder.addCase(addSupplier.fulfilled, (state, action) => {
      state.suppliers.push(action.payload.data);
    });

    builder.addCase(addSupplier.rejected, (state, action) => {
      //state.error = action.payload.error || null;
    });

    builder.addCase(updateSupplier.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Updating Supplier...", {
        position: "top-center",
        autoClose: false,
      });
      state.error = {};
    });

    builder.addCase(updateSupplier.fulfilled, (state, action) => {
      state.suppliers = state.suppliers.map((supplier) =>
        supplier.sup_id.toString() === action.payload.data.sup_id.toString()
          ? { ...supplier, ...action.payload.data }
          : supplier
      );
    });

    builder.addCase(updateSupplier.rejected, (state, action) => {
      //  state.error = action.payload.error || null;
    });

    builder.addCase(deleteSupplier.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Deleting Supplier...", {
        position: "top-center",
        autoClose: false,
      });
      state.error = {};
    });

    builder.addCase(deleteSupplier.fulfilled, (state, action) => {
      state.suppliers = (state.suppliers || []).filter(
        (supplier) =>
          supplier.sup_id.toString() !== action.payload.data.sup_id.toString()
      );
    });

    builder.addCase(deleteSupplier.rejected, (state, action) => {
      // state.error = action.payload.error || null;
    });
  },
});

export default SuppliersSlice.reducer;
